export default __webpack_public_path__ + "static/media/tokenmetric.403f3926.png";